module.exports = __webpack_public_path__ + "img/sqrt-swap-dagger.2a0d28d6.svg";